import { Component, computed, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'wm-front-skeleton-line',
  imports: [],
  templateUrl: './skeleton-line.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './skeleton-line.component.scss',
})
export class SkeletonLineComponent {
  public width = computed(() => {
    const choices = [55, 62, 70, 78, 85, 92]
    const idx = Math.floor(Math.random() * choices.length)
    return `${choices[idx]}%`
  })
}
